import type { ReactNode } from 'react';
import { PageContainer } from '../PageContainer/PageContainer';
import { TemplateSection } from './Section';

export type AboutTemplateProps = {
  /** A Hero (as="h1") with an illustration. */
  hero: ReactNode;
  /** StatTiles with live index counts from the build-time snapshot and their source. */
  stats?: ReactNode;
  /** The team: Cards with Avatar, name and role (real people, with their consent). */
  team?: { title: ReactNode; content: ReactNode };
  /** Milestones as a Timeline. */
  milestones?: { title: ReactNode; content: ReactNode };
  className?: string;
};

/** About, team and partnerships pages, and author pages. No stock photos. */
export function AboutTemplate({ hero, stats, team, milestones, className }: AboutTemplateProps) {
  return (
    <PageContainer className={className}>
      <div className="flex flex-col gap-jc-section pb-jc-section">
        {hero}
        {stats ? <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">{stats}</div> : null}
        {team ? (
          <TemplateSection id="team" title={team.title}>
            <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{team.content}</div>
          </TemplateSection>
        ) : null}
        {milestones ? (
          <TemplateSection id="milestones" title={milestones.title} className="max-w-2xl">
            {milestones.content}
          </TemplateSection>
        ) : null}
      </div>
    </PageContainer>
  );
}
